// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import * as Icons$LiteracyplanetClientSxEntry from "./Icons.res.mjs";
import * as HeaderIcons$LiteracyplanetClientSxEntry from "./HeaderIcons.res.mjs";
import * as SecondaryStyles$LiteracyplanetClientSxEntry from "./SecondaryStyles.res.mjs";

function SecondaryComponents$HeaderBackground(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.HeaderBackground.className
            }, props.children);
}

var HeaderBackground = {
  make: SecondaryComponents$HeaderBackground
};

function SecondaryComponents$HeaderPanel(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.HeaderPanel.className
            }, props.children);
}

var HeaderPanel = {
  make: SecondaryComponents$HeaderPanel
};

function SecondaryComponents$SlimHeaderItemIcon(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderItemIcon.className
            }, props.children);
}

var SlimHeaderItemIcon = {
  make: SecondaryComponents$SlimHeaderItemIcon
};

function SecondaryComponents$AcademyIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Academy.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var AcademyIcon = {
  make: SecondaryComponents$AcademyIcon
};

function SecondaryComponents$WordFlyersIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.WordFlyers.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var WordFlyersIcon = {
  make: SecondaryComponents$WordFlyersIcon
};

function SecondaryComponents$PlanetIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Planet.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var PlanetIcon = {
  make: SecondaryComponents$PlanetIcon
};

function SecondaryComponents$ChestIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Chest.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var ChestIcon = {
  make: SecondaryComponents$ChestIcon
};

function SecondaryComponents$AvatarIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Avatar.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var AvatarIcon = {
  make: SecondaryComponents$AvatarIcon
};

function SecondaryComponents$LetterAIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Lettera.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var LetterAIcon = {
  make: SecondaryComponents$LetterAIcon
};

function SecondaryComponents$ArcadeIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Arcade.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var ArcadeIcon = {
  make: SecondaryComponents$ArcadeIcon
};

function SecondaryComponents$MyWordsIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.MyWords.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var MyWordsIcon = {
  make: SecondaryComponents$MyWordsIcon
};

function SecondaryComponents$MagazineIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Magazine.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var MagazineIcon = {
  make: SecondaryComponents$MagazineIcon
};

function SecondaryComponents$MagazineDropdownIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Magazine.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.DropdownHeaderIcon.className
            });
}

var MagazineDropdownIcon = {
  make: SecondaryComponents$MagazineDropdownIcon
};

function SecondaryComponents$BookDropdownIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Book.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.DropdownHeaderIcon.className
            });
}

var BookDropdownIcon = {
  make: SecondaryComponents$BookDropdownIcon
};

function SecondaryComponents$LibraryIcon(props) {
  return React.createElement(HeaderIcons$LiteracyplanetClientSxEntry.Library.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimIcon.className
            });
}

var LibraryIcon = {
  make: SecondaryComponents$LibraryIcon
};

function SecondaryComponents$SlimHeaderItemButton(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderItemButton.className(props.highlight, props.itemColor, props.hoverColor, props.activeColor)
            }, props.children);
}

var SlimHeaderItemButton = {
  make: SecondaryComponents$SlimHeaderItemButton
};

function SecondaryComponents$SlimHeaderItem(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderItem.className,
              onClick: props.onClick
            }, props.children);
}

var SlimHeaderItem = {
  make: SecondaryComponents$SlimHeaderItem
};

function SecondaryComponents$SlimHeaderLockIcon(props) {
  return React.createElement(Icons$LiteracyplanetClientSxEntry.LockSmallIcon.make, {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderLockIcon.className
            });
}

var SlimHeaderLockIcon = {
  make: SecondaryComponents$SlimHeaderLockIcon
};

function SecondaryComponents$SlimHeaderNotificationCount(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderNotificationCount.className
            }, String(props.count));
}

var SlimHeaderNotificationCount = {
  make: SecondaryComponents$SlimHeaderNotificationCount
};

function SecondaryComponents$SlimHeaderItemWrapper(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.SlimHeaderItemWrapper.className
            }, props.children);
}

var SlimHeaderItemWrapper = {
  make: SecondaryComponents$SlimHeaderItemWrapper
};

function SecondaryComponents$AcademySlimHeaderItem(props) {
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Academy"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: React.createElement(SecondaryComponents$AcademyIcon, {})
                      })
                }));
}

var AcademySlimHeaderItem = {
  make: SecondaryComponents$AcademySlimHeaderItem
};

function SecondaryComponents$WordFlyersSlimHeaderItem(props) {
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Word Flyers"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: React.createElement(SecondaryComponents$WordFlyersIcon, {})
                      })
                }));
}

var WordFlyersSlimHeaderItem = {
  make: SecondaryComponents$WordFlyersSlimHeaderItem
};

function SecondaryComponents$MissionsSlimHeaderItem(props) {
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Missions"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.missionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$PlanetIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null)
                }));
}

var MissionsSlimHeaderItem = {
  make: SecondaryComponents$MissionsSlimHeaderItem
};

function SecondaryComponents$CollectionsSlimHeaderItem(props) {
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Collections"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.collectionsColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.collectionsHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.collectionsActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$ChestIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null)
                }));
}

var CollectionsSlimHeaderItem = {
  make: SecondaryComponents$CollectionsSlimHeaderItem
};

function SecondaryComponents$ArcadeSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Arcade"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.arcadeColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.arcadeHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.arcadeActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$ArcadeIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(SecondaryComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var ArcadeSlimHeaderItem = {
  make: SecondaryComponents$ArcadeSlimHeaderItem
};

function SecondaryComponents$AvatarSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Shop"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.avatarColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.avatarHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.avatarActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$AvatarIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(SecondaryComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var AvatarSlimHeaderItem = {
  make: SecondaryComponents$AvatarSlimHeaderItem
};

function SecondaryComponents$MyWordsSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("My Words"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.myWordsColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.myWordsHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.myWordsActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$MyWordsIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(SecondaryComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var MyWordsSlimHeaderItem = {
  make: SecondaryComponents$MyWordsSlimHeaderItem
};

function SecondaryComponents$IntrepizineSlimHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Intrepizine"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$MagazineIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(SecondaryComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var IntrepizineSlimHeaderItem = {
  make: SecondaryComponents$IntrepizineSlimHeaderItem
};

function SecondaryComponents$DropdownHeaderPanel(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.DropdownHeaderPanel.className
            }, props.children);
}

var DropdownHeaderPanel = {
  make: SecondaryComponents$DropdownHeaderPanel
};

function SecondaryComponents$DropdownHeaderItem(props) {
  return React.createElement("div", {
              className: SecondaryStyles$LiteracyplanetClientSxEntry.DropdownHeaderItem.className,
              onClick: props.onClick
            }, props.children);
}

var DropdownHeaderItem = {
  make: SecondaryComponents$DropdownHeaderItem
};

function SecondaryComponents$BooksDropdownItem(props) {
  return React.createElement(SecondaryComponents$DropdownHeaderItem, {
              children: null,
              onClick: props.onClick
            }, React.createElement(SecondaryComponents$BookDropdownIcon, {}), SecondaryStyles$LiteracyplanetClientSxEntry.s("Books"));
}

var BooksDropdownItem = {
  make: SecondaryComponents$BooksDropdownItem
};

function SecondaryComponents$IntrepizineDropdownItem(props) {
  return React.createElement(SecondaryComponents$DropdownHeaderItem, {
              children: null,
              onClick: props.onClick
            }, React.createElement(SecondaryComponents$MagazineDropdownIcon, {}), SecondaryStyles$LiteracyplanetClientSxEntry.s("Intrepizine"));
}

var IntrepizineDropdownItem = {
  make: SecondaryComponents$IntrepizineDropdownItem
};

function SecondaryComponents$LibraryClosedHeaderItem(props) {
  var __lock = props.lock;
  var __notificationCount = props.notificationCount;
  var notificationCount = __notificationCount !== undefined ? __notificationCount : 0;
  var lock = __lock !== undefined ? __lock : false;
  return React.createElement(SecondaryComponents$SlimHeaderItem, {
              onClick: props.onClick,
              children: null
            }, React.createElement(SecondaryComponents$SlimHeaderItemButton, {
                  children: SecondaryStyles$LiteracyplanetClientSxEntry.s("Library"),
                  itemColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryColor,
                  hoverColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryHoverColor,
                  activeColor: SecondaryStyles$LiteracyplanetClientSxEntry.libraryActiveColor,
                  highlight: props.highlight
                }), React.createElement(SecondaryComponents$SlimHeaderItemIcon, {
                  children: React.createElement(SecondaryComponents$SlimHeaderItemWrapper, {
                        children: null
                      }, React.createElement(SecondaryComponents$LibraryIcon, {}), notificationCount > 0 ? React.createElement(SecondaryComponents$SlimHeaderNotificationCount, {
                              count: notificationCount
                            }) : null, lock ? React.createElement(SecondaryComponents$SlimHeaderLockIcon, {}) : null)
                }));
}

var LibraryClosedHeaderItem = {
  make: SecondaryComponents$LibraryClosedHeaderItem
};

function SecondaryComponents$LibraryOpenDropdown(props) {
  return React.createElement(SecondaryComponents$DropdownHeaderPanel, {
              children: null
            }, React.createElement(SecondaryComponents$BooksDropdownItem, {
                  onClick: props.onClickLibrary
                }), React.createElement(SecondaryComponents$IntrepizineDropdownItem, {
                  onClick: props.onClickIntrepizine
                }));
}

var LibraryOpenDropdown = {
  make: SecondaryComponents$LibraryOpenDropdown
};

function SecondaryComponents$LibrarySlimHeaderItem(props) {
  var openSubnav = props.openSubnav;
  var closeSubnav = props.closeSubnav;
  var onClickIntrepizine = props.onClickIntrepizine;
  var onClickLibrary = props.onClickLibrary;
  var highlightLibrary = props.highlightLibrary;
  var lockLibrary = props.lockLibrary;
  if (lockLibrary) {
    return React.createElement(SecondaryComponents$LibraryClosedHeaderItem, {
                highlight: highlightLibrary,
                onClick: (function (param) {
                    Curry._1(onClickIntrepizine, undefined);
                  }),
                lock: lockLibrary
              });
  } else if (props.subnavOpen) {
    return React.createElement("div", undefined, React.createElement(SecondaryComponents$LibraryClosedHeaderItem, {
                    highlight: highlightLibrary,
                    onClick: (function (param) {
                        Curry._1(closeSubnav, undefined);
                      }),
                    lock: lockLibrary
                  }), React.createElement(SecondaryComponents$LibraryOpenDropdown, {
                    onClickLibrary: (function (param) {
                        Curry._1(onClickLibrary, undefined);
                        Curry._1(closeSubnav, undefined);
                      }),
                    onClickIntrepizine: (function (param) {
                        Curry._1(onClickIntrepizine, undefined);
                        Curry._1(closeSubnav, undefined);
                      })
                  }));
  } else {
    return React.createElement(SecondaryComponents$LibraryClosedHeaderItem, {
                highlight: highlightLibrary,
                onClick: (function (param) {
                    Curry._1(openSubnav, undefined);
                  }),
                lock: lockLibrary
              });
  }
}

var LibrarySlimHeaderItem = {
  make: SecondaryComponents$LibrarySlimHeaderItem
};

var ratio = Theme$LiteracyplanetClientFlags.resize;

export {
  ratio ,
  HeaderBackground ,
  HeaderPanel ,
  SlimHeaderItemIcon ,
  AcademyIcon ,
  WordFlyersIcon ,
  PlanetIcon ,
  ChestIcon ,
  AvatarIcon ,
  LetterAIcon ,
  ArcadeIcon ,
  MyWordsIcon ,
  MagazineIcon ,
  MagazineDropdownIcon ,
  BookDropdownIcon ,
  LibraryIcon ,
  SlimHeaderItemButton ,
  SlimHeaderItem ,
  SlimHeaderLockIcon ,
  SlimHeaderNotificationCount ,
  SlimHeaderItemWrapper ,
  AcademySlimHeaderItem ,
  WordFlyersSlimHeaderItem ,
  MissionsSlimHeaderItem ,
  CollectionsSlimHeaderItem ,
  ArcadeSlimHeaderItem ,
  AvatarSlimHeaderItem ,
  MyWordsSlimHeaderItem ,
  IntrepizineSlimHeaderItem ,
  DropdownHeaderPanel ,
  DropdownHeaderItem ,
  BooksDropdownItem ,
  IntrepizineDropdownItem ,
  LibraryClosedHeaderItem ,
  LibraryOpenDropdown ,
  LibrarySlimHeaderItem ,
}
/* react Not a pure module */
